// Generated by CoffeeScript 1.3.3





/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {


    var $instagramWrap;

    $(document).ready( function () {
      $instagramWrap = $('.insta-wrap');

      if ( $instagramWrap.length > 0 ){
        getSJInstagram();
      }
    });
    function get_instagram(info, successCallback, afterCallback){
      //requirements:
      //  instafeed.js
      //  <div id="instafeed"></div> on the page
      //
      //in the info object:
      //clientId:   instagram clientId
      //userId:     user
      //accessToken:  access token (received after user authorizes)
      //template:   is an instafeed template
      //limit:    # of items returned by instagram
      //
      //success:   a callback, with an obj argument, do something with it
      //after:   a callback for after success
      //  
      // you can add to a filter with:
      // filter: function(image) {
      //   return image.tags.indexOf('TAG_NAME') >= 0;
      // }
      var userFeed = new Instafeed({
          get:      'user',
          clientId:     info.clientId,
          resolution:   "standard_resolution",
        userId:     info.userId, 
        accessToken:  info.accessToken,
        limit:      info.num_news_items,
        template:     info.template,
        success:    function (obj) {
          if (typeof successCallback === "function"){
            successCallback.call(this, obj);
          }     
        },
        after: function () {
          if (typeof afterCallback === "function"){
            afterCallback.call(this);
          }
        }
      });
      userFeed.run();
    }

    // https://api.instagram.com/oauth/authorize/?client_id=5385342dd9b34931942ebc5b7ffbade5&redirect_uri=sarahsnaps.com&response_type=code



    //5385342dd9b34931942ebc5b7ffbade5
    var sjfClientId = "5385342dd9b34931942ebc5b7ffbade5";
    var sjfUserId = 255892021;

    
    var sjfAccessToken = "255892021.5385342.49987adc35684f88b81cf34b490b6ad3";
    // var sjfAccessToken = "c78f3efe9eb44f67beea257ff1b197ec";

    function getSJInstagram(){

      var instafeed_template = '<a data-large="{{image}}" class="gallery-item" data-post="{{caption}}" style="background-image: url({{image}});"></a>'
      var instafeed_limit = 20; 
      get_instagram(
          {
              clientId:       sjfClientId,
              userId:         sjfUserId,
              accessToken:    sjfAccessToken,
              template:       instafeed_template,
              limit:          instafeed_limit
          }, 
          function (obj) {
              instagramToDoc(obj);
          }
      );
    }

    function instagramToDoc(obj){
      var posts = obj.data;
      var nav_out = "";
      for (var i = 0; i < posts.length; i++){
        console.log(posts[i].images);
        var this_thumb =  posts[i].images.thumbnail.url;
        var standard =  posts[i].images.standard_resolution.url;
        var this_id =     posts[i].id;
        nav_out += '<a data-large="' + standard + '" style="background-image: url(' + this_thumb + ')" href="#' + this_id + '"></a>';
      }
      $instagramWrap.html(nav_out);
    }

	

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);


  ( function () {

    var $viewer;

    var $imgPopup;
    var $imgPopupWrap;

    

    /*function setGalleryImageOld(imageUrl){
      if (!imageUrl){
        $viewer.css('background-image', '');
        $('.thumbs-wrap').show();
      }
      else{
        $viewer.css('background-image', 'url(' + imageUrl + ')');  
        $('.thumbs-wrap').hide();
      }
    }
    function setGalleryImage(imageUrl, mousePos){
      if (!imageUrl){
        // $imgPopupWrap.fadeOut(300, function () {
          $imgPopupWrap.removeClass('visible');
        // });
        // $imgPopup.css('background-image', 'none');
        // setTimeout( function () {
          
        // }, 1000);
      }
      else{
        $imgPopup.css('background-image', 'url(' + imageUrl + ')');
        $imgPopupWrap.addClass('visible');
      }
    }*/
    function setGalleryImage(imageUrl, mousePos){
      if (!imageUrl){
          $imgPopupWrap.removeClass('visible');
      }
      else{
        $imgPopup.css('background-image', 'url(' + imageUrl + ')');
        $imgPopupWrap.addClass('visible');
      }
    }

    $(document).ready( function () {
      var galleryPage = $('body').hasClass('page-template-template-gallery');
      $imgPopup = $('.image-popup .image-wrap');
      $imgPopupWrap = $('.image-popup');

      $viewer = $('.main');
      if (galleryPage){

        $(document).on("click", '.gallery-item', function (e){
          // var mousePos = {
          //   x: parseInt((e.clientX / $(window).width()) * 100),
          //   y: parseInt((e.clientY / $(window).height()) * 100)
          // };
          var myImageLarge = $(this).attr('data-large');
          setGalleryImage(myImageLarge);
        });
        $('.image-popup').on("click", function () {
          setGalleryImage('');
        });

      }

        $(document).on('click', '.menu-link', function () {
          $('.mobile-menu').toggleClass('visible');
        });

        $(document).on('keydown', function(e){
          var KEY_ESCAPE = 27;
          var KEY_BACK = 8;
          var KEY_LEFT = 37;
          var KEY_RIGHT = 39;

          var keyOut = e.keyCode === KEY_ESCAPE 
                        || e.keyCode === KEY_BACK
                        || e.keyCode === KEY_LEFT
                        || e.keyCode === KEY_RIGHT;

          if (keyOut && $imgPopupWrap.hasClass('visible')){
            e.preventDefault();
            e.stopPropagation();
            $imgPopupWrap.removeClass('visible');
          }
          

        });

    });
    

    /*
      Cache larger versions when hovering over thumbnails
    */
    var imgCache = {};
    $(document).on("mouseenter", ".gallery-item", function () {
      var myImg = $(this).attr('data-large');
      if ( !imgCache[myImg] ){
        imgCache[myImg] = new Image();
        imgCache[myImg].src = myImg;
      }
    });

    window.onhashchange = function () {
      var hash = location.hash;
      if (hash === ''){
        setGalleryImage('');
      }
      console.log(location.hash);
    };
  })();


})(jQuery); // Fully reference jQuery after this point.



